import axios from 'axios';
import { authFirebase } from './firebase.config';

const apiClientBid = axios.create({
  baseURL: import.meta.env.VITE_BASEURL,
  headers: {
    'Content-Type': 'application/json'
  },
});

apiClientBid.interceptors.request.use(
  async (config) => {
    const user = authFirebase.currentUser;
    if (user) {
      const idToken = await user.getIdToken(true);
      config.headers.Authorization = `Bearer ${idToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

authFirebase.onAuthStateChanged(async (user) => {
  if (user) {
    const idToken = await user.getIdToken(true);
    apiClientBid.defaults.headers.common['Authorization'] = `Bearer ${idToken}`;
  }
});

export default apiClientBid;
